import { render, staticRenderFns } from "./PayrollLaborCostPanel.vue?vue&type=template&id=14d8c485&scoped=true&"
import script from "./PayrollLaborCostPanel.vue?vue&type=script&lang=js&"
export * from "./PayrollLaborCostPanel.vue?vue&type=script&lang=js&"
import style0 from "./PayrollLaborCostPanel.vue?vue&type=style&index=0&id=14d8c485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d8c485",
  null
  
)

export default component.exports